import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Register from "../pages/register/Register";
import Profile from "../pages/profile/Profile";
import Home from "../pages/Home/Home";
import HeroSlider from "../components/HeroSlider/HeroSlider"
import Games from "../components/Games/Games"
import Services from "../components/Services/Services";
import Pubg from "../pages/Pubg/PubgDetal";
import TikTok from "../pages/TikTok/TikTokDetal";
import FreeFire from "../pages/FreeFire/FreeFireDetal";
import MobileLegends from "../pages/MobileLegends/MobilLegDetal";
import MobileAccessory from "../pages/MobileAccessory/MobileD";
import Lounge from "../pages/Lounge/LoungeDetal";
import Menyu from "../pages/Menyu/Menyu";
import Note from "../pages/Note/NoteDetal";
import ScrollToTop from "./ScrollToTop";
import AboutDetal from "../pages/About/AboutDetal";
import PhoneDetal from "../pages/Phone/PhoneDetal";
import SupportDetal from "../pages/Support/SupportDetal";
import SikayetDetal from "../pages/Şikayet/SikayetDetal";



const Router = () => {
  return (
    <BrowserRouter>
    <ScrollToTop/>
      <Routes>
        <Route path="/" element={<Home />}  />
        <Route path="/HeroSlider" element={<HeroSlider />}  />
        <Route path="/Services" element={<Services />}  />
        <Route path="/Games" element={<Games />}  />
        <Route path="/pubg" element={<Pubg />}  />
        <Route path="/tiktok" element={<TikTok />}  />
        <Route path="/freeFire" element={<FreeFire />}  />
        <Route path="/mobileLegends" element={<MobileLegends />}  />
        <Route path="/mobileAccessory" element={<MobileAccessory />}  />
        <Route path="/lounge" element={<Lounge />}  />
        <Route path="/menyu" element={<Menyu />}  />
        <Route path="/about" element={<AboutDetal />}  />
        <Route path="/phone" element={<PhoneDetal />}  />
        <Route path="/support" element={<SupportDetal />}  />
        <Route path="/şikayət" element={<SikayetDetal />}  />
        <Route path="/note" element={<Note />}  />

        <Route path="/register" element={<Register />} />
       
          <Route path="/profile" element={<Profile/>} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
